import { useState } from 'react';
import { Logo } from '../components/ui/bits.jsx';
import { useUI } from '../components/ui/feedback.jsx';
import { InstallButton, InstallHelpModal } from '../components/InstallPrompt.jsx';
import { signInWithGoogle } from '../lib/api.js';
import { Zasebnost } from './Zasebnost.jsx';
import { Icon } from '../components/ui/Icon.jsx';
import { JEZIKI, lang, setLang, t } from '../i18n/index.js';
import { ZA_SOLE_URL } from '../config.js';

export function Login() {
  const { toast } = useUI();
  const [busy, setBusy] = useState(false);
  const [help, setHelp] = useState(false);
  // /?zasebnost=1 odpre politiko zasebnosti brez prijave (povezava s strani Za šole).
  const [zasebnost, setZasebnost] = useState(() => {
    try {
      return new URLSearchParams(window.location.search).get('zasebnost') === '1';
    } catch {
      return false;
    }
  });
  const [, rerender] = useState(0);

  const go = async () => {
    setBusy(true);
    try {
      await signInWithGoogle();
      // Ob uspehu brskalnik odide na Google; sem se ne vrnemo.
    } catch (e) {
      setBusy(false);
      toast.bad(e.message ?? 'Prijava ni uspela. Poskusi znova.');
    }
  };

  return (
    <main
      className="stack"
      style={{
        minHeight: '100dvh',
        maxWidth: 420,
        margin: '0 auto',
        padding: 'var(--s-6) var(--s-4)',
        justifyContent: 'center',
      }}
    >
      <div className="card card--raised card--pad stack stack--loose">
        <div className="stack" style={{ alignItems: 'center', textAlign: 'center' }}>
          <Logo height={150} />
          <div>
            <h1 className="t-xl">{t('Dobrodošel v Učilnici')}</h1>
            <p className="t-md t-dim" style={{ marginTop: 'var(--s-1)' }}>
              {t('Tvoj program šolanja, knjižica letenja in pot do izpita — na enem mestu.')}
            </p>
          </div>
        </div>

        <button className="btn btn--secondary btn--lg btn--block" onClick={go} disabled={busy}>
          <GoogleMark />
          {busy ? t('Odpiram Google …') : t('Prijava z Google računom')}
        </button>

        <p className="t-xs t-dimmer" style={{ textAlign: 'center' }}>
          Učilnica · {t('Program šolanja')}
          <br />
          <button
            className="t-xs"
            style={{ textDecoration: 'underline', padding: 'var(--s-1) 0' }}
            onClick={() => setZasebnost(true)}
          >
            {t('Varstvo osebnih podatkov')}
          </button>
        </p>
      </div>

      <div className="stack stack--tight" style={{ alignItems: 'center' }}>
        <InstallButton onNeedHelp={() => setHelp(true)} block />

        <div className="row" style={{ gap: 'var(--s-1)' }} role="group" aria-label="Jezik / Language">
          <Icon name="globe" size={15} className="t-dimmer" />
          {JEZIKI.map((j) => (
            <button
              key={j.key}
              className={`btn btn--sm ${lang() === j.key ? 'btn--secondary' : 'btn--ghost'}`}
              aria-pressed={lang() === j.key}
              onClick={() => {
                setLang(j.key);
                rerender((n) => n + 1);
              }}
            >
              {j.key.toUpperCase()}
            </button>
          ))}
        </div>

        <a className="t-sm t-dim" href={ZA_SOLE_URL}>
          {t('Si šola jadralnega padalstva?')} <strong>{t('Učilnica za vašo šolo')}</strong>
        </a>
      </div>

      {help && <InstallHelpModal onClose={() => setHelp(false)} />}
      {zasebnost && <Zasebnost onClose={() => setZasebnost(false)} />}
    </main>
  );
}

function GoogleMark() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
        fill="#4285F4"
      />
      <path
        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
        fill="#34A853"
      />
      <path
        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
        fill="#FBBC05"
      />
      <path
        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
        fill="#EA4335"
      />
    </svg>
  );
}
